export function stopPropagation(event: React.MouseEvent<Element>) {
  event.stopPropagation();
}

export function stopSubmition(event: React.FormEvent<Element>) {
  event.stopPropagation();
  event.preventDefault();
}
